export const donationConstants = {
	DonationGetByFilterRequest : "DONATION_GET_BYFILTER_STARTED",
	DonationGetByFilterSuccess : "DONATION_GET_BYFILTER_COMPLETED",
	DonationGetByFilterFailure : "DONATION_GET_BYFILTER_FAILED",

	DonationRecurringGetByFilterRequest : "DONATION_RECURRING_GET_BYFILTER_STARTED",
	DonationRecurringGetByFilterSuccess : "DONATION_RECURRING_GET_BYFILTER_COMPLETED",
	DonationRecurringGetByFilterFailure : "DONATION_RECURRING_GET_BYFILTER_FAILED",
}